<template>
  <List striped bordered>
    <ListItem
      v-for="(item, index) in props.usps.values"
      :key="index"
      icon-color="green"
      icon="System/check-line">
      <div :class="$style['item']">
        {{ item }}
      </div>
    </ListItem>
  </List>
</template>
<script setup>
const props = defineProps({
  usps: {
    type: [Object, Array, Boolean],
    default: null
  }
})

</script>
<style lang="scss" module>
.product-usps {
  svg {
    fill: var(--gold);
    margin-right: var(--spacing);
  }
}

.item{
  width: 90%;
}
</style>
